import { render, staticRenderFns } from "./sign-loges.vue?vue&type=template&id=90cc61f8&"
import script from "./sign-loges.vue?vue&type=script&lang=ts&"
export * from "./sign-loges.vue?vue&type=script&lang=ts&"
import style0 from "./sign-loges.vue?vue&type=style&index=0&id=90cc61f8&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports